<i18n>
{
  "fr": {
    "log-action-CREATE-label": "Création",
    "log-action-UPDATE-label": "Modification",
    "log-action-communication-label": "Communication",
    "log-action-reminder-label": "Relance",
    "log-action-STATUS_CHANGE-label": "Changement de statut",
    "log-action-UPDATE_STORAGE_INFO-label": "Ouverture du stockage",
    "log-action-REMINDER-label": "Rappel envoyé",
    "from": "De",
    "to": "à",
    "status-undefined": "Non défini",
    "status-waiting": "En attente de téléversement",
    "status-cancel": "Annulé",
    "status-running": "En cours",
    "status-done": "Terminé"
  }
}
</i18n>

<template>

  <div class="log-card">
    <md-card>
      <md-ripple>
        <md-card-header>
          <div class="md-title" v-html="$t(`log-action-${log.type}-label`)"></div>
          <div class="md-subtitle">{{ logDate }}{{ logUser }}</div>
        </md-card-header>

        <md-card-content v-if="logContent !== ''" v-html="logContent">
        </md-card-content>
      </md-ripple>
    </md-card>
  </div>

</template>

<script>

import moment from 'moment'

export default {
  name: 'LogCard',
  props: {
    log: {
      type: Object
    }
  },
  computed: {
    logDate () {
      return moment.utc(this.log.value.date).format('DD.MM.YYYY HH:mm')
    },
    logUser () {
      return typeof this.log.user === 'undefined' || this.log.user === null ? '' : ` | ${this.log.user.firstname} ${this.log.user.lastname}`
    },
    logContent () {
      switch (this.log.type) {
        case 'communication':
        case 'storage-opened':
        case 'reminder':
          return this.log.value.message
        case 'STATUS_CHANGE':
          return `${this.$t('from')} <i>${this.$t('status-' + String(this.log.value.from))}</i> ${this.$t('to')} <i>${this.$t('status-' + this.log.value.to)}</i>`
        default:
          return ''
      }
    }
  },
  event: 'change',
  data () {
    return {

    }
  }
}
</script>

<style lang="scss">
  .log-card {
    padding: 5px;
    user-select: none;
  }
</style>
